import { createFileRoute, redirect } from '@tanstack/react-router'
import { supabase } from '@/lib/supabase'

export const Route = createFileRoute('/auth/logout')({ 
  loader: async () => {
    await supabase.auth.signOut()
    throw redirect({ to: '/' })
  },
  component: () => null
})